import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import {
  arrayOf, string, number, oneOfType, node
} from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Image } from '@thd-olt-component-react/core-ui';
import styles from './hero.module.scss';
import { StoryHero } from './StoryHero';

const cx = classNames.bind(styles);
const Hero = ({
  imageUrl, pageHref, children, componentId, componentClass, componentPosition, width, height
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('hero.ready'); }, []);

  if (componentId && componentClass) {
    return (
      <StoryHero
        componentId={componentId}
        componentClass={componentClass}
        componentPosition={componentPosition}
      />
    );
  }

  return (
    <div className={cx('hero')}>
      <a href={pageHref}>
        <Image className={cx('hero__image')} alt="Hero" src={imageUrl} width={width} height={height} />
        <span>
          {children}
        </span>
      </a>
    </div>
  );
};

Hero.propTypes = {
  imageUrl: string,
  pageHref: string,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  children: oneOfType([node, arrayOf(node)]),
  componentId: string,
  componentClass: string,
  componentPosition: number
};

Hero.defaultProps = {
  children: null,
  componentId: '',
  componentClass: '',
  componentPosition: 1,
  imageUrl: '',
  pageHref: '',
  width: null,
  height: null
};

Hero.displayName = 'Hero';

Hero.dataModel = extend({}, StoryHero);

export { Hero };
